import { useRoutes } from '../../';

// ---------- set GoTo Router (with All Screens Access)
export const goTo = (newRoute: string) => {
  console.log('goTo', newRoute);
  return useRoutes.setState({ currRoute: newRoute });
};
